import { defineStore } from 'pinia';

export const useChatSettingsStore = defineStore('ai-chat-settings', () =>
{
    const aiChatSettings = ref<ChatSettingsModel>(defaultAiChatSettings());

    function loadAiChatSettings()
    {
        AiChatService.getSettings()
            .then((data) =>
            {
                aiChatSettings.value = data;
            })
            .catch((error) =>
            {
                console.error(error);
            });
    }

    async function reload()
    {
        await loadAiChatSettings();
    }

    reload();

    return { aiChatSettings, reload };
});
